"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _image = require("@site/pattern-library-core/image");
/**
 * Local Imports
 */

const ImageContainer = /*#__PURE__*/(0, _react2.styled)(_image.LazyPicture)({
  name: "ImageContainer",
  class: "pl-i1odht19"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hg6pcp9",
  vars: {
    "hg6pcp9-1": [({
      backgroundColor = 'initial'
    }) => backgroundColor]
  }
});

/**
 * HPJourneySection Component.
 * @module HPJourneySection
 *
 * @param {Object} props React props
 * @param {String} props._name Impression Tracking
 * @param {Object} props.portrait Mobile Image
 * @param {Object} props.tablet Tablet Image
 * @param {Object} props.landscape Desktop Image
 * @param {String} props.textAlign Content Alignment
 * @param {String} props.backgroundColor Background Color
 * @returns {React.ReactElement} HPJourneySection Component
 * @public
 */

function HPJourneySection({
  _name,
  portrait,
  tablet,
  landscape,
  backgroundColor,
  verticalMargin,
  ...rest
}) {
  const {
    url: portraitUrl,
    alt: portraitAlt
  } = portrait;
  const {
    url: tabletUrl
  } = tablet;
  const {
    url: landscapeUrl
  } = landscape;
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    _name: _name,
    dataCy: "hp-journey-section",
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(ImageContainer, {
    defaultSrc: portraitUrl,
    defaultAltText: portraitAlt,
    dataCy: "image-container"
  }, /*#__PURE__*/_react.default.createElement("source", {
    srcSet: tabletUrl,
    media: `${_patternLibraryUtils.deviceMax.tablet}`
  }), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: landscapeUrl,
    media: `${_patternLibraryUtils.device.tabletLg}`
  })), /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    backgroundColor: backgroundColor,
    "data-cy": "headline-container"
  }, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({}, rest, {
    textAlign: "start",
    eyebrowTag: "h2",
    headlineSize: "h2",
    headlineTag: "h3"
  }))));
}
var _default = exports.default = HPJourneySection;
HPJourneySection.propTypes = {
  _name: _propTypes.default.string,
  portrait: _propTypes.default.object,
  tablet: _propTypes.default.object,
  landscape: _propTypes.default.object,
  textAlign: _propTypes.default.string,
  headlineSize: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  ..._patternLibraryUtils.marginProps
};